import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useBackend } from "../backend/BackendProvider";
import { mutationContext } from "../backend/mutation";
import { useToast } from "../components/ToastProvider";
import { useNavigate } from "react-router-dom";

export function RepeatEngine() {
  const backend = useBackend(); const queryClient = useQueryClient(); const { show } = useToast(); const navigate = useNavigate();
  const preferences = useQuery({ queryKey: ["preferences"], queryFn: () => backend.preferences.get() });
  const processing = useQuery({
    queryKey: ["repeat-processing", preferences.data?.timezone],
    queryFn: () => backend.repeats.processDue(new Date().toISOString(), preferences.data!.timezone, mutationContext()),
    enabled: Boolean(preferences.data),
    refetchInterval: 60_000,
    retry: false,
  });
  useEffect(() => {
    if (!processing.data?.generatedTaskIds.length) return;
    void Promise.all([queryClient.invalidateQueries({ queryKey: ["view"] }), queryClient.invalidateQueries({ queryKey: ["tasks"] }), queryClient.invalidateQueries({ queryKey: ["repeating"] })]);
    show(`${processing.data.generatedTaskIds.length} ${processing.data.generatedTaskIds.length === 1 ? "Task was" : "Tasks were"} generated because a Repeat trigger was reached.`, { label: "Review Repeating", run: () => navigate("/repeating") });
  }, [navigate, processing.data, queryClient, show]);
  return null;
}
